import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { UserService } from "../../services/user/user.service";
import { MerchantService } from "../../services/merchant/merchant.service";
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NeedAuthorize } from "../../classes/needAuthorize";
import { Global } from "../../classes/global";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { escapeRegExp } from 'lodash';
import { ToastrService } from "ngx-toastr";
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-setup-tiktok-flash-sale',
  templateUrl: './setup-tiktok-flash-sale.component.html',
  styleUrls: ['./setup-tiktok-flash-sale.component.scss']
})
export class SetupTiktokFlashSaleComponent implements OnInit {
  @ViewChild('setupTiktokFlashSaleModal') setupTiktokFlashSaleModal: ElementRef;

  @Input() merchant: any;

  setupFlashSaleForm: FormGroup;

  note:any;

  constructor(private global: Global,
    private modalService: NgbModal,
    private merchantService: MerchantService,
    private toastr: ToastrService,
    private fb: FormBuilder) {

    this.setupFlashSaleForm = this.fb.group({
      discount: [20, [Validators.required, Validators.min(1), Validators.max(100)]],
      startTime: [this.getDefaultStartTime(), Validators.required],
      hourDuration: [24, [Validators.required, Validators.min(1)]],
      isAutoRenew: [false],
      isActivated: [true]
    });

  }

  ngOnInit(): void {
  }

  openSetupTiktokFlashSaleModal() {
    this.global.pageLoading = true;
    this.merchantService.getTiktokFlashSaleForMerchant(this.merchant.merchantId)
      .subscribe(data => {
        console.log(data);
        this.global.pageLoading = false;

        if (data != null) {
          this.setupFlashSaleForm.patchValue({
            isActivated: data?.isActivated,
            discount: data?.discountPercentage,
            startTime: data?.startTime
              ? new Date(data.startTime).toISOString().slice(0, 16)
              : this.getDefaultStartTime(),
            hourDuration: data?.hourDuration,
            isAutoRenew: data?.isAutoRenew
          });

          this.note = data.note;
        }
        
        this.modalService.open(this.setupTiktokFlashSaleModal, { windowClass: "xlModal" });
      });
  }

  setupTiktokFlashSaleApi() {
    if (this.setupFlashSaleForm.invalid) {
      alert('Please fill in all required fields correctly.');
      return;
    }

    const formData = this.setupFlashSaleForm.value;

    const startDate = new Date(formData.startTime);

    const requestPayload = {
      isActivated: formData.isActivated,
      merchantId: this.merchant.merchantId,
      isAutoRenew: formData.isAutoRenew,
      discountPercentage: parseFloat(formData.discount),
      startTime: startDate.toISOString(),
      hourDuration: formData.hourDuration
    };

    this.merchantService.setupTiktokFlashSale(requestPayload).subscribe(
      (data) => {
        this.toastr.success('Cài đặt FlashSale đã lưu và đang chờ chạy');

        this.modalService.dismissAll();
      },
      error => {
        this.toastr.success('Lỗi khi lưu');
        this.modalService.dismissAll();
      }
    );
  }

  priority() {
    this.merchantService.priorityFlashSale(this.merchant.merchantId).subscribe(
      (data) => {
        this.toastr.success('Cài đặt FlashSale đã vào hàng chờ ưu tiên');

        this.modalService.dismissAll();
      },
      error => {
        this.toastr.success('Lỗi khi lưu');
        this.modalService.dismissAll();
      }
    );
  }

  getDefaultStartTime(): string {
    const now = new Date();
    now.setHours(now.getHours() + 1, 0, 0, 0); // Set to next full hour
    return now.toISOString().slice(0, 16); // Format for datetime-local input
  }
}
